module.exports = {
	"shared.crew.original-music-composer": "मूल संगीत/संगीतकार",
	"social-button.twitter": "ट्वीटर",
	"shared.crew.publicist": "पत्रकार",
	"share-overlay.share": "इस वीडियो को साझा करे",
	"shared.crew.associate-producer": "सहयोगी निर्माता",
	"shared.crew.assistant-editor": "सहायक संपादक",
	"overlay.buy-from": "{price} से खरीदें",
	"shared.crew.agent": "एजेंट",
	"shared.crew.additional-photography": "अतिरिक्त फोटोग्राफी",
	"shared.crew.sound-editor": "ध्वनि संपादक",
	"shared.crew.print-shipper": "प्रिन्ट शिपर",
	"shared.crew.hairstylist": "बालों की स्टाइल बनाने वाला",
	"shared.crew.makeup-effects": "मेकअप प्रभाव",
	"social-button.pinterest": "प्रिंटेरेस्ट",
	"shared.crew.production-assistant": "प्रोडक्शन सहायक",
	"shared.crew.executive-producer": "कार्यकारी निर्माता",
	"shared.crew.costumer": "ग्राहक",
	"info-overlay.cast": "कास्ट",
	"shared.crew.stunt-coordinator": "स्टंट समन्वयक",
	"shared.crew.academic-advisor": "शैक्षणिक सलाहकार",
	"shared.crew.swing-gang": "स्विंग गैंग",
	"shared.crew.best-boy": "सर्वोत्तम लड़का",
	"actions.purchased": "आप इस वीडियो के मालिक हैं",
	"social-button.tumblr": "टम्ब्लर",
	"quality.format": "{qualityValue}p",
	"shared.crew.set-decorator": "सेट सजानेवाला ",
	"shared.crew.adaptation": "अनुकूलन",
	"shared.crew.school-administrator": "स्कूल प्रशासक",
	"shared.crew.cable-person": "केबलवाला व्यक्ति",
	"shared.crew.digital-effects": "डिजिटल प्रभाव",
	"actions.rent": "{price} किराया",
	"info-overlay.created-by": "{author} द्वारा ",
	"social-share.twitter": "{siteUrl} पर \"{title}\" देखिए",
	"shared.crew.production-designer": "प्रोडक्शन डिजाइनर",
	"info-overlay.crew": "कर्मीदल",
	"shared.crew.producer": "निर्माता",
	"shared.crew.2nd-unit-dir-of-photography": "फोटोग्राफी का दुसरा यूनिट निर्देशक",
	"shared.crew.special-effects": "विशेष प्रभाव",
	"actions.rented": "{date} तक किराये पर",
	"shared.crew.boom-operator": "बूम संचालक",
	"shared.crew.story": "कहानी",
	"shared.crew.script-supervisor": "पटकथा पर्यवेक्षक",
	"shared.crew.director": "निर्देशक",
	"shared.crew.choreographer": "कोरियोग्राफर",
	"shared.crew.production-manager": "प्रोडक्शन प्रबंधक",
	"quality.auto": "स्वत: ",
	"shared.crew.lead-person": "नेतृत्व करनेवाली व्यक्ति",
	"shared.crew.location-manager": "स्थान प्रबंधक",
	"shared.crew.costume-designer": "पोशाक बनाने वाला",
	"fullscreen.exit": "पूर्ण स्क्रीन से बाहर निकलें",
	"shared.crew.technical-advisor": "तकनीकी सलाहकार",
	"shared.crew.editor": "संपादक",
	"shared.crew.additional-grip": "अतिरिक्त पकड़",
	"actions.buy": "{price} खरीदें",
	"shared.crew.assistant-camera": "सहायक कैमरा",
	"shared.crew.writer": "लेखक",
	"social-share.pinterest": "{title} - {description}",
	"shared.crew.collaborating-director": "सहयोगी निर्देशक ",
	"fullscreen.enter": "पूर्ण स्क्रीन",
	"shared.crew.animal-trainer": "जानवरों का प्रशिक्षक",
	"shared.crew.assistant-art-director": "सहायक कला निर्देशक",
	"shared.crew.key-grip": "मुख्य पकड़",
	"social-button.copy": "कॉपि करे",
	"shared.crew.makeup-artist": "मेकअप कलाकार",
	"overlay.source-error": "वीडियो नहीं चलाया जा सकता",
	"social-button.link": "लिंक करें",
	"actions.buy-from": "{price} से खरीदें",
	"shared.crew.art-director": "कला निर्देशक",
	"shared.crew.production-coordinator": "प्रोडक्शन समन्वयक",
	"shared.crew.co-director": "सह निर्देशक",
	"shared.crew.co-producer": "सह निर्माता",
	"shared.crew.video-operator": "वीडियो ऑपरेटर",
	"shared.crew.camera-operator": "कैमरा संचालक",
	"shared.crew.co-writer": "सह-लेखक",
	"shared.crew.set-designer": "सेट डिजाइनर",
	"shared.crew.preview-return": "पूर्वावलोकन वापसी",
	"shared.crew.property-master": "संपत्ति मास्टर",
	"shared.crew.cinematographer-dp": "छायाकार/DP",
	"shared.crew.grip": "पकड़ ",
	"social-share.tumblr": "{title} - {siteUrl}",
	"shared.crew.sound-mixer": "ध्वनि मिश्रक",
	"quality.label": "गुणवता ",
	"social-button.facebook": "फेसबुक",
	"shared.crew.gaffer": "वृद्ध",
	"shared.crew.assistant-director": "सहायक निर्देशक",
	"actions.subscribe": "सदस्यता लें {price}/माह",
	"shared.crew.print-return": "प्रिन्ट वापसी",
	"shared.crew.animator": "एनिमेटर",
	"shared.crew.dolly-grip": "डॉली पकड़",
	"shared.crew.manager": "प्रबंधक",
	"shared.crew.2nd-assistant-director": "दुसरा सहायक निर्देशक",
	"shared.crew.author-of-adapted-material": "अनुकूलित सामग्री के लेखक"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_hi.json
// module id = 2789
// module chunks = 66